import React from 'react';
import './GetStartedNow.css';

const GetStartedNow = () => {
  return (
    <div className="getstartednow-container">
      {/* Content will be added later */}
    </div>
  );
};

export default GetStartedNow;
